<template>
  <form v-on:submit="save" action="#" method="post" id="">

    <div class="row">
      <div class="col-xs-3" v-if="$auth.check('super_admin')">
        <div class="form-group">
          <label for="profile" class="required">Profile
            <span v-if="errorProfileSelected" class="error">{{ errorProfileSelected }}</span>
          </label>
          <v-select2 id="profile" label="name" :options="profiles" v-model="profileSelected" required></v-select2>
        </div>
      </div>

      <div class="col-xs-3" :class="{'col-xs-offset-1': $auth.check('super_admin')}">
        <div class="form-group">
          <label for="plan" class="required">Plan Type
            <span v-if="errorPlanSelected" class="error">{{ errorPlanSelected }}</span>
          </label>
          <v-select2 id="plan" :options="plans" label="name" v-model="planSelected"/>
        </div>
      </div>

      <div class="col-xs-3 col-xs-offset-1">
        <div class="form-group">
          <label for="role" class="required">Role
            <span v-if="errorRoleSelected" class="error">{{ errorRoleSelected }}</span>
          </label>
          <v-select2 id="role" label="display_name" :options="roles" v-model="roleSelected"></v-select2>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-xs-2">
        <div class="form-group">
          <label for="expired_at" class="required">Renewal date
            <span v-if="errorExpiredAt" class="error">{{ errorExpiredAt }}</span>
          </label>
          <date-picker id="expired_at" v-model="expiredAt" :config="configDate"
                       :disabled="!$auth.check('super_admin')"/>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 15px">
      <div class="col-xs-2">
        <div class="form-group">
          <label for="nb_science_search" class="required">Science Search
            <span v-if="errorNbScienceSearchRemained" class="error">{{ errorNbScienceSearchRemained }}</span>
          </label>
          <input type="number" min="-1" max="100" v-model="nbScienceSearchRemained"
                 id="nb_science_search" class="form-control" :disabled="!$auth.check('super_admin')">
          <span class="help-block m-b-none">Use -1 for unlimited</span>
        </div>
      </div>
      <div class="col-xs-2 col-xs-offset-2">
        <div class="form-group">
          <label for="nb_patent_search" class="required">Patent Search
            <span v-if="errorNbPatentSearchRemained" class="error">{{ errorNbPatentSearchRemained }}</span>
          </label>
          <input type="number" min="-1" max="100" v-model="nbPatentSearchRemained"
                 id="nb_patent_search" class="form-control" :disabled="!$auth.check('super_admin')">
          <span class="help-block m-b-none">Use -1 for unlimited</span>
        </div>
      </div>
      <div class="col-xs-2 col-xs-offset-2">
        <div class="form-group ">
          <label for="nb_company_search" class="required">Company Search
            <span v-if="errorNbCompanySearchRemained" class="error">{{ errorNbCompanySearchRemained }}</span>
          </label>
          <input type="number" min="-1" max="100" v-model="nbCompanySearchRemained"
                 id="nb_company_search" class="form-control" :disabled="!$auth.check('super_admin')">
          <span class="help-block m-b-none">Use -1 for unlimited</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-2">
        <div class="form-group ">
          <label for="nb_search_affiliation" class="required">Find Affiliation
            <span v-if="errorNbSearchAffiliationRemained" class="error">{{ errorNbSearchAffiliationRemained }}</span>
          </label>
          <input type="number" min="-1" max="100" v-model="nbSearchAffiliationRemained"
                 id="nb_search_affiliation" class="form-control" :disabled="!$auth.check('super_admin')">
          <span class="help-block m-b-none">Use -1 for unlimited</span>
        </div>
      </div>
      <div class="col-xs-2 col-xs-offset-2">
        <div class="form-group">
          <label for="nb_project_remained" class="required">Project Storage
            <span v-if="errorNbProjectStorageRemained" class="error">{{ errorNbProjectStorageRemained }}</span>
          </label>
          <input type="number" min="-1" max="100" v-model="nbProjectStorageRemained"
                 id="nb_project_remained" class="form-control" :disabled="!$auth.check('super_admin')">
          <span class="help-block m-b-none">Use -1 for unlimited</span>
        </div>
      </div>
      <div class="col-xs-2 col-xs-offset-2">
        <div class="form-group">
          <label for="nb_mailing_remained" class="required">Mailing
            <span v-if="errorNbMailingRemained" class="error">{{ errorNbMailingRemained }}</span>
          </label>
          <input type="number" min="-1" max="100" v-model="nbMailingRemained"
                 id="nb_mailing_remained" class="form-control" :disabled="!$auth.check('super_admin')">
          <span class="help-block m-b-none">Use -1 for unlimited</span>
        </div>
      </div>

    </div>

    <div class="row" style="margin-top: 15px">
      <div class="col-xs-2">
        <div class="form-group">
          <div class="checkbox checkbox-info checkbox-inline">
            <span v-if="errorAccountProvisioning" class="error">{{ errorAccountProvisioning }}</span>
            <input id="account_provisioning" type="checkbox" v-model="accountProvisioning" :disabled="!$auth.check('super_admin')">
            <label for="account_provisioning" > Account provisioning</label>
          </div>
        </div>
      </div>
      <div class="col-xs-2 col-xs-offset-2">
        <div class="form-group">
          <div class="checkbox checkbox-info checkbox-inline">
            <input id="account_advance_news" type="checkbox" v-model="accountAdvanceNews" :disabled="!$auth.check('super_admin')">
            <label for="account_advance_news" > Account Advance News</label>
          </div>
        </div>
      </div>
      <div class="col-xs-2 col-xs-offset-2">
        <div class="form-group">
          <div class="checkbox checkbox-info checkbox-inline">
            <input id="account_blockchain" type="checkbox" v-model="accountBlockchain" :disabled="!$auth.check('super_admin')">
            <label for="account_blockchain" > Account blockchain</label>
          </div>
        </div>
      </div>
    </div>

    <div class="text-right m-t-xs">
      <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save changes</vue-ladda>
    </div>
  </form>
</template>
<script>

import VueLadda from 'vue-ladda'
import vSelect2 from '../../components/utils/select2'
import DatePicker from 'vue-bootstrap-datetimepicker'

export default {
  components: {vSelect2, VueLadda, DatePicker},
  name: 'PlanCredit',
  props: ['user'],
  data () {
    return {
      configDate: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      },
      plans: [],
      roles: [],
      profiles: [],
      profileSelected: null,
      roleSelected: null,
      planSelected: null,
      nbScienceSearchRemained: null,
      nbPatentSearchRemained: null,
      nbCompanySearchRemained: null,
      nbSearchAffiliationRemained: null,
      nbProjectStorageRemained: null,
      nbMailingRemained: null,
      accountProvisioning: null,
      accountBlockchain: null,
      accountAdvanceNews: null,
      expiredAt: null,
      errorProfileSelected: null,
      errorRoleSelected: null,
      errorPlanSelected: null,
      errorNbScienceSearchRemained: null,
      errorNbPatentSearchRemained: null,
      errorNbCompanySearchRemained: null,
      errorNbSearchAffiliationRemained: null,
      errorNbProjectStorageRemained: null,
      errorNbMailingRemained: null,
      errorAccountProvisioning: null,
      errorExpiredAt: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  watch: {
    profileSelected: function (profile) {
      this.getPlansAvailable()
    },
    planSelected: function (plan) {
      this.getRolesAvailable()

      if (plan !== null) {
        this.nbScienceSearchRemained = plan.nb_science_search
        this.nbPatentSearchRemained = plan.nb_patent_search
        this.nbCompanySearchRemained = plan.nb_company_search
        this.nbSearchAffiliationRemained = plan.nb_search_affiliation
        this.nbProjectStorageRemained = plan.nb_project_storage
        this.nbMailingRemained = plan.nb_mailing
        this.accountProvisioning = plan.account_provisioning
        this.accountBlockchain = plan.account_blockchain
        this.accountAdvanceNews = plan.account_advance_news
      } else {
        this.nbScienceSearchRemained = null
        this.nbPatentSearchRemained = null
        this.nbCompanySearchRemained = null
        this.nbSearchAffiliationRemained = null
        this.nbProjectStorageRemained = null
        this.nbMailingRemained = null
        this.accountProvisioning = false
        this.accountBlockchain = false
        this.accountAdvanceNews = false
        this.expiredAt = null
      }
    }
  },
  methods: {
    save: async function (event) {
      event.preventDefault()

      this.submit.loading = true

      this.errorProfileSelected = null
      this.errorRoleSelected = null
      this.errorPlanSelected = null
      this.errorNbScienceSearchRemained = null
      this.errorNbPatentSearchRemained = null
      this.errorNbCompanySearchRemained = null
      this.errorNbSearchAffiliationRemained = null
      this.errorNbProjectStorageRemained = null
      this.errorNbMailingRemained = null
      this.errorAccountProvisioning = null
      this.errorExpiredAt = null

      this.axios.patch('/user/' + this.user.id + '/planCredit', {
        nb_science_search_remained: this.nbScienceSearchRemained,
        nb_patent_search_remained: this.nbPatentSearchRemained,
        nb_company_search_remained: this.nbCompanySearchRemained,
        nb_search_affiliation_remained: this.nbSearchAffiliationRemained,
        nb_project_storage_remained: this.nbProjectStorageRemained,
        nb_mailing_remained: this.nbMailingRemained,
        account_provisioning: this.accountProvisioning,
        account_blockchain: this.accountBlockchain,
        account_advance_news: this.accountAdvanceNews,
        expired_at: this.expiredAt,
        profile_id: this.profileSelected.id,
        plan_id: this.planSelected.id,
        role_id: this.roleSelected.id
      }).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Credits changed',
          placement: 'bottom-right'
        })
        this.$salesMachine.editUser(response.data)
      }).catch((error) => {
        let errors = error.response.data.errors

        if (typeof errors['nb_science_search_remained'] !== 'undefined') {
          this.errorNbScienceSearchRemained = errors['nb_science_search_remained'][0]
        } if (typeof errors['nb_patent_search_remained'] !== 'undefined') {
          this.errorNbPatentSearchRemained = errors['nb_patent_search_remained'][0]
        } if (typeof errors['nb_company_search_remained'] !== 'undefined') {
          this.errorNbCompanySearchRemained = errors['nb_company_search_remained'][0]
        } if (typeof errors['nb_search_affiliation_remained'] !== 'undefined') {
          this.errorNbSearchAffiliationRemained = errors['nb_search_affiliation_remained'][0]
        } if (typeof errors['nb_project_storage_remained'] !== 'undefined') {
          this.errorNbProjectStorageRemained = errors['nb_project_storage_remained'][0]
        } if (typeof errors['nb_mailing_remained'] !== 'undefined') {
          this.errorNbMailingRemained = errors['nb_mailing_remained'][0]
        } if (typeof errors['account_provisioning'] !== 'undefined') {
          this.errorAccountProvisioning = errors['account_provisioning'][0]
        } if (typeof errors['expired_at'] !== 'undefined') {
          this.errorExpiredAt = errors['expired_at'][0]
        } if (typeof errors['profile_id'] !== 'undefined') {
          this.errorProfileSelected = errors['profile_id'][0]
        } if (typeof errors['plan_id'] !== 'undefined') {
          this.errorPlanSelected = errors['plan_id'][0]
        } if (typeof errors['role_id'] !== 'undefined') {
          this.errorRoleSelected = errors['role_id'][0]
        }

        this.$notify({
          type: 'danger',
          title: 'A error was occurred',
          placement: 'bottom-right'
        })

      }).finally(() => {
        this.submit.loading = false
      })
    },
    getResources: function () {
      if (this.$auth.check('super_admin')) {
        this.getProfiles()
      } else {
        this.getPlansAvailable()
      }
    },
    getProfiles: function () {
      this.axios.get('/profiles/')
        .then((response) => {
          this.profiles = response.data
        })
        .catch((error) => {
        })
    },
    getPlansAvailable: function () {
      this.axios.get('/profile/' + this.profileSelected.id + '/plansAvailable')
        .then((response) => {
          this.plans = response.data
          this.planSelected = this.user.plan_credit.plan
        })
        .catch((error) => {
        })
    },
    getRolesAvailable: function () {
      this.axios.get('/plan/' + this.planSelected.id + '/rolesAvailable')
        .then((response) => {
          this.roles = response.data
        })
        .catch((error) => {
        })
    }
  },
  beforeMount () {
    this.profileSelected = this.user.profile
    this.roleSelected = this.user.roles[0]

    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/PlanCredit.vue